// MailTo.js
'use strict';
import { connect } from 'react-redux';
import MailTo from '../component/MailTo.jsx';

import getMeData from '../selector/getMeData.js';
import submitEmailToSupport from '../action/submitEmailToSupport.js';
import sendCurrentRemoteConfig from '../action/sendCurrentRemoteConfig.js';

function mapStateToProps(state) {
  return {
    hasCustomerServiceToken: !!(
      getMeData(state, 'intercomUserHash') || getMeData(state, 'zendeskUserJwt')
    ),
    hasClientId: !!getMeData(state, 'clientId'),
  };
}

const mapDispatchToProps = dispatch => ({
  submitEmailToSupport: data => dispatch(submitEmailToSupport(data)),
  sendCurrentRemoteConfig: () => dispatch(sendCurrentRemoteConfig()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MailTo);
